const version = 100;
const storagePrefix = 'vue-';

export function createLocalStorage(name) {
    return createStorage(localStorage, name);
}

export function createSessionStorage(name) {
    return createStorage(sessionStorage, name);
}

function createStorage(storageInterface, baseName) {
    let appVersion = parseInt(storageInterface.getItem(storagePrefix + 'appVersion'), 10);

    if (appVersion !== version) {
        storageInterface.setItem(storagePrefix + baseName, '{}');
        storageInterface.setItem(storagePrefix + 'appVersion', version);
    }

    let data = tryParseJSON(storageInterface.getItem(storagePrefix + baseName), {});

    return {
        reload: () => {
            data = tryParseJSON(storageInterface.getItem(storagePrefix + baseName), {});
        },
        set: (name, value) => {
            data[name] = value;
            storageInterface.setItem(storagePrefix + baseName, JSON.stringify(data));
        },
        get: (name, defaultValue = null) => {
            return name in data ? data[name] : defaultValue;
        }
    };
}

function tryParseJSON(jsonValue, defaultValue = {}) {
    if (!jsonValue) {
        return defaultValue;
    }

    try {
        return JSON.parse(jsonValue);
    } catch (e) {
        return defaultValue;
    }
}
